"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGhostCompact = exports.ButtonTertiaryCompact = exports.ButtonPrimaryCompact = exports.ButtonSecondaryCompact = exports.ButtonGhost = exports.ButtonTertiary = exports.ButtonSecondary = exports.ButtonPrimary = void 0;
var react_1 = __importDefault(require("react"));
var styled_1 = require("./styled");
var react_router_dom_1 = require("react-router-dom");
var lodash_1 = require("lodash");
var icons_1 = require("../../../icons");
var colors_1 = require("../../themes/colors");
var Typo2_1 = require("../Typo2");
var mixins_1 = require("../../../themes/mixins");
var DisplayIcon = function (_a) {
    var icon = _a.icon, size = _a.size, color = _a.color, iconWeight = _a.iconWeight;
    var IconComp = icons_1.icons[icon];
    return react_1.default.createElement("div", { style: { minWidth: 'max-content', display: "flex", justifyContent: "center", alignItems: "center" } }, IconComp && react_1.default.createElement(IconComp, { size: size, color: color, weight: iconWeight || 'bold' }));
};
var Typos = {
    UI_BODY_SEMIBOLD_SM_DF: Typo2_1.UI_BODY_SEMIBOLD_SM_DF,
    UI_CAPTION_SEMIBOLD_DF: Typo2_1.UI_CAPTION_SEMIBOLD_DF
};
var ButtonStyledWrapper = function (_a) {
    var props = _a.props, variant = _a.variant;
    var responsive_ = (0, mixins_1.useResponsiveMobileStyles)(props.responsive);
    var id = props.id, link = props.link, children = props.children, value = props.value, submit = props.submit, icon = props.icon, iconAfter = props.iconAfter, onClick = props.onClick, onMouseDown = props.onMouseDown, active = props.active, disabled = props.disabled, theme = props.theme, width = props.width, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, color = props.color, style = props.style, className = props.className, S = props.S, M = props.M, iconSize = props.iconSize, _iconColor = props.iconColor, iconWeight = props.iconWeight, stopPropagation = props.stopPropagation, preventDefault = props.preventDefault, forceHover = props.forceHover, typo = props.typo;
    var displayText = (link === null || link === void 0 ? void 0 : link.displayText) || children || value;
    var debouncedOnClick = onClick && (0, lodash_1.debounce)(onClick, 200);
    var debouncedMouseDown = onMouseDown && (0, lodash_1.debounce)(onMouseDown, 150);
    var composition = (icon || iconAfter) && displayText
        ? "icon+text"
        : !displayText
            ? "iconOnly"
            : "textOnly";
    var size = ['icon+text', 'textOnly'].indexOf(composition) !== -1
        ? (S && 'S') || 'M'
        : (M && 'M') || 'S'; // this size logic dont have design defination yet, default size is "S"
    var calcIconSize = function () {
        var thisSize = iconSize || size;
        return typeof thisSize === 'number' ? thisSize : (thisSize === 'S' && responsive_) ? 18 : (thisSize === 'S' && !responsive_) ? 16 : 20;
    };
    var iconColor = !disabled ? _iconColor : colors_1.colors.grey40;
    var DisplayTextTypo = Typos[typo] || Typo2_1.UI_BODY_SEMIBOLD_SM_DF;
    return (react_1.default.createElement(styled_1.ButtonStyled, { id: id, style: style, className: className, variant: variant, size: size, active: active, disabled: disabled, theme: theme, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, type: submit ? "submit" : "button", onClick: function (e) {
            stopPropagation && e.stopPropagation();
            preventDefault && e.preventDefault();
            debouncedOnClick && debouncedOnClick(e);
        }, onMouseDown: function (e) {
            stopPropagation && e.stopPropagation();
            preventDefault && e.preventDefault();
            debouncedMouseDown && debouncedMouseDown(e);
        }, composition: composition, width: width, color: color, forceHover: forceHover, responsive: responsive_ },
        icon && react_1.default.createElement(DisplayIcon, { icon: icon, color: iconColor, size: calcIconSize(), iconWeight: iconWeight || '' }),
        displayText && react_1.default.createElement(DisplayTextTypo, null, displayText),
        iconAfter && react_1.default.createElement(DisplayIcon, { icon: iconAfter, color: iconColor, size: calcIconSize(), iconWeight: iconWeight || '' })));
};
/**
 * Generates a Button component based on the provided props and variant.
 *
 * @prop { ButtonProps } props - The properties for the Button component
 * @prop { string } variant - The variant of the Button component
 * @return { ReactNode } The Button component to be rendered
 */
var Button = function (_a) {
    var props = _a.props, variant = _a.variant;
    var link = props.link, onClick = props.onClick;
    var buttonAction = link ? function () { return null; } : onClick;
    return link ? (react_1.default.createElement(react_router_dom_1.Link, { to: link.val },
        react_1.default.createElement(ButtonStyledWrapper, { props: __assign(__assign({}, props), { onClick: buttonAction }), variant: variant }))) : (react_1.default.createElement(ButtonStyledWrapper, { props: __assign(__assign({}, props), { onClick: buttonAction }), variant: variant }));
};
var ButtonPrimary = function (props) { return (react_1.default.createElement(Button, { props: props, variant: "primary" })); };
exports.ButtonPrimary = ButtonPrimary;
var ButtonSecondary = function (props) { return (react_1.default.createElement(Button, { props: props, variant: "secondary" })); };
exports.ButtonSecondary = ButtonSecondary;
var ButtonTertiary = function (props) { return (react_1.default.createElement(Button, { props: props, variant: "tertiary" })); };
exports.ButtonTertiary = ButtonTertiary;
var ButtonGhost = function (props) { return (react_1.default.createElement(Button, { props: props, variant: "ghost" })); };
exports.ButtonGhost = ButtonGhost;
var ButtonSecondaryCompact_1 = require("./derivedComps/ButtonSecondaryCompact");
Object.defineProperty(exports, "ButtonSecondaryCompact", { enumerable: true, get: function () { return ButtonSecondaryCompact_1.ButtonSecondaryCompact; } });
var ButtonPrimaryCompact_1 = require("./derivedComps/ButtonPrimaryCompact");
Object.defineProperty(exports, "ButtonPrimaryCompact", { enumerable: true, get: function () { return ButtonPrimaryCompact_1.ButtonPrimaryCompact; } });
var ButtonTertiaryCompact_1 = require("./derivedComps/ButtonTertiaryCompact");
Object.defineProperty(exports, "ButtonTertiaryCompact", { enumerable: true, get: function () { return ButtonTertiaryCompact_1.ButtonTertiaryCompact; } });
var ButtonGhostCompact_1 = require("./derivedComps/ButtonGhostCompact");
Object.defineProperty(exports, "ButtonGhostCompact", { enumerable: true, get: function () { return ButtonGhostCompact_1.ButtonGhostCompact; } });
